import React, { ReactNode, useState } from 'react';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { formatText } from '../text/utils';
import { colors } from '../../theme/colors';
import Zoom from '@mui/material/Zoom';
import { fontSize } from '../../theme/typography';
import { isMobileScreen } from '../../theme/spacing';
type CustomTooltipProps = TooltipProps & {
  interactive?: boolean;
};

type MainTooltipProps = {
  title: ReactNode; // Accepts string or any React element
  tooltipCustomization?: Partial<CustomTooltipProps>;
  children: React.ReactNode;
};

const MainTooltip: React.FC<MainTooltipProps> = ({
  title,
  children,
  tooltipCustomization,
}) => {
  const [openTooltip, setOpenTooltip] = useState(false);
  const [clicked, setClicked] = useState(false);

  const handleTooltipClick = () => {
    setClicked(!clicked); // Toggle click state
    setOpenTooltip(!openTooltip); // Toggle tooltip state
  };

  const handleTooltipHover = () => {
    if (!clicked) {
      setOpenTooltip(true);
    }
  };

  const handleTooltipLeave = () => {
    if (!clicked) {
      setOpenTooltip(false);
    }
  };

  const handleClickAway = () => {
    setClicked(false);
    setOpenTooltip(false);
  };

  const titleContent = typeof title === 'string' ? formatText(title) : title; // Apply formatText if title is a string

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div onMouseEnter={handleTooltipHover} onMouseLeave={handleTooltipLeave}>
        <Tooltip
          TransitionComponent={Zoom}
          title={<div onClick={handleTooltipClick}>{titleContent}</div>} // Use titleContent wrapped in div with onClick handler
          open={openTooltip}
          PopperProps={{
            sx: {
              '& .MuiTooltip-tooltip': {
                backgroundColor: colors.backgroundSuperLight,
                color: colors.textPrimary,
                lineHeight: 1.333,
                fontSize: isMobileScreen ? fontSize.sm : fontSize.md,
              },
            },
          }}
          {...tooltipCustomization}
        >
          <div onClick={handleTooltipClick}>{children}</div>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default MainTooltip;
